import { ajaxSend } from 'api/api';
const v1Path = '/v1/chatbots';
export function getChatBots({ path = v1Path, }) {
    return ajaxSend({ path }, true).then((res) => ({
        data: res.data,
        meta: {
            next_page: null,
            prev_page: null,
        },
    }));
}
